import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import GetWays from "./components/GetWays";
import HotResources from "./components/HotResources";
import Categories from "./components/Categories";
import Updates from "./components/Updates";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <GetWays />
        <HotResources />
        <Categories />
        <Updates />
        <Guide />
        <Faq />
        <About />
      </main>
      <Footer />
    </div>
  );
}